import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {RoadKill} from "../RoadKill";
import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {RoadKillModel} from "../server/RoadKillModel";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RKHelper} from "../utils/RKHelper";
import {RoadKillSound} from "../sound/RoadKillSound";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {RoadKillWinConfigs} from "../RoadKillWinConfigs";

export class RoadKillNormalBetPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController) {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    flowStateController.finish();
                }
            }),
            delay: number = RoadKillGameConfig.STEP_DURATION,
            data: RoadKillModel = RoadKill.model,
            animationName: string = RKHelper.getTransitionAnimName(data.mode, data.nextMode);
        RoadKill.winToggle.stopWinToggle();
        RoadKill.reelView.modifyFakeReelSetToAddRemoveS1(RoadKill.model.evaluatedArea, RoadKill.model.mode, RoadKill.model.nextMode);
        if (RoadKill.model.isRoundComplete) {
            tl.add(() => {
                RoadKill.jumpingWildView.reset();
                RoadKill.lifeView.reset();
                RoadKill.topAnimalController.getJWPopOutAnim();
                RoadKill.backgroundElements.updateMultiplier(1);
                RoadKill.topAnimalController.reset();
            });
            SimpleReelModel.SPEED = 1;
        }
        tl.add(RoadKill.jumpingWildView.onSpinStart());
        tl.add([RoadKill.winCapView.onReelStart(), RoadKill.bigWinView.onReelStart(), () => {
            RoadKill.massiveWinView.onReelStart()
        }]);
        if (RoadKill.model.gameData && RoadKillWinConfigs.getWinType(RoadKill.model.winRatio) === RoadKillWinConfigs.TINY) {
            tl.add(() => {
                RoadKill.initialWinView.onReelStart(1);
            }, "<")
        } else {
            tl.add(RoadKill.initialWinView.onReelStart(), "<")
        }

        tl.add(() => {
            RoadKill.reelView.onReelStart();
        }, 0);
        const reelTl: TimelineLite = new TimelineLite();
        tl.add(reelTl, 0);
        reelTl.add(RoadKill.reelView.reelModels[0].start(false), 0);
        if (!data.isRestore) {
            if ((data.mode === RoadKillGameMode.FREESPIN && data.nextMode === RoadKillGameMode.NORMAL) || (data.mode === RoadKillGameMode.SUPER_FREESPIN && data.nextMode === RoadKillGameMode.NORMAL) || (data.mode === RoadKillGameMode.RESPIN && data.nextMode === RoadKillGameMode.NORMAL)) {
                reelTl.add([RoadKill.backgroundSpine.playTransitionAnim(animationName), () => {
                    if (data.mode === RoadKillGameMode.SUPER_FREESPIN) {
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.jumpingWildView, true);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.reelView);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.winToggle);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.backgroundElements);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.topAnimalCounterView);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.lifeView);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.winCapView);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.initialWinView);
                        RoadKillUtils.fsTransition(0.75, false, RoadKill.bigWinView);
                        RoadKill.soundPlayer.playTrack(RoadKillSound.SFS_TO_MAIN_TRASITION);
                    }
                }], "<");
                reelTl.add(() => {
                    RoadKill.backgroundSpine.changeBackground(RoadKillGameMode.NORMAL);
                })
            }
        }
        reelTl.add(RoadKill.reelView.reelModels[1].start(false), delay);
        reelTl.add(RoadKill.reelView.reelModels[2].start(false), delay * 2);
        reelTl.add(RoadKill.reelView.reelModels[3].start(false), delay * 3);
        reelTl.add(RoadKill.reelView.reelModels[4].start(false), delay * 4);
    }
}